import React, { Component, Fragment } from 'react';
import 'react-datetime/css/react-datetime.css';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';

import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import ViewsTable from '../../../components/tables/ViewsTable';
import LoadingWizard from '../../../components/spinner/wizard';
import EngagementTeam from './engagementTeam';
import AddTeamModal from './modals/addTeamModal';
import API from '../../../utils/API';
import DeleteEngagementTeamsModal from './modals/deleteEngagementTeamsModal';
class LeaderboardTeams extends Component {
    constructor(props) {
        super(props);

        const columns = {
            name: 'Name',
            groupName: 'Group',
            rank: 'Rank',
            points: 'Points',
            attendeeCount: 'Attendees',
            createdAt: 'Created At',
            updatedAt: 'Last Updated'
        };
        const columnTypes = {
            name: 'text',
            groupName: 'text',
            rank: 'number',
            points: 'number',
            attendeeCount: 'number',
            createdAt: 'date',
            updatedAt: 'date'
        };

        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });


        this.state = {
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            checkedItems: {},
            feedItems: [],
            isGridLayout: true,
            loading: true,
            markedItem: null,
            toggleAddTeam: false,
            searchTerm: '',
            engagementTeams: [],
            sidePanelOpen: false,
            toggleDeleteEngagementTeams: false
        };
    }

    async componentDidMount() {
        const { orgId, eventId, event } = this.props;
        this.props.setSelectedTab(3);

        await API().get(`Organizations/${orgId}/events/${eventId}/engagementteams`).then((res) => {
            if (res.data) {
                /* link */
                let data = res.data;
                data.map((item, i) => {
                    item.link = `/${orgId}/events/${eventId}/engagement/leaderboardTeams/${item._id}`;
                    item.rank = i + 1;

                });


                this.setState({ engagementTeams: data });

            }
        }).catch((err) => {
            console.log(err);
        });



        this.setState({
            loading: false,
        });
    }



    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false
        });
    };

    toggleLayout = (selected) => {
        this.setState({ isGridLayout: selected });
    };
    updatedCheckedItems = (checked) => {
        this.setState({ checkedItems: checked });
    };


    toggleAddTeam = () => {
        this.setState({ toggleAddTeam: !this.state.toggleAddTeam });
    }


    toggleDeleteGallery = () => {
        this.setState({ toggleDeleteGallery: !this.state.toggleDeleteGallery });
    }

    removeGallery = (feedIds, callback) => {
        this.props.removeGallery(feedIds, () => {
            this.setState({ checkedItems: {}, markedItem: null }, () => {
                callback && callback();
            });
        });
    }

    toggleSingleDeleteGallery = (galleryId) => {
        this.setState({ markedItem: galleryId, toggleDeleteGallery: true });
    }

    addNewTeam = async (team, cb) => {
        const { engagementTeams } = this.state;
        const { orgId, eventId } = this.props;

        await API().get(`Organizations/${orgId}/events/${eventId}/engagementteams`).then((res) => {
            if (res.data) {
                /* link */
                let data = res.data;
                data.map((item, i) => {
                    item.link = `/${orgId}/events/${eventId}/engagement/leaderboardTeams/${item._id}`;
                    item.rank = i + 1;

                });


                this.setState({ engagementTeams: data }, () => { cb && cb() });

            }
        }).catch((err) => {
            console.log(err);
        });

    }
    updateTeams = (updatedTeams, cb) => {
        const { engagementTeams } = this.state;
        const { orgId, eventId } = this.props;




        let data = updatedTeams;
        data.map((item, i) => {
            item.link = `/${orgId}/events/${eventId}/engagement/leaderboardTeams/${item._id}`;
            item.rank = i + 1;

        });


        this.setState({ engagementTeams: data }, () => { cb && cb() });
    }

    toggleDeleteEngagementTeams = () => {
        this.setState({ toggleDeleteEngagementTeams: !this.state.toggleDeleteEngagementTeams });
    }

    deleteEngagementTeams = (cb) => {
        const { checkedItems } = this.state;
        const { orgId, eventId } = this.props;
        const teamIds = Object.keys(checkedItems);
        this.setState({ loading: true });

        API().delete(`Organizations/${orgId}/events/${eventId}/engagementteams`, { data: { deleteEngagmentTeams: teamIds } }).then((res) => {
            if (res.data) {
                this.setState({ loading: false, checkedItems: {} }, () => {

                    let data = this.state.engagementTeams.filter((team) => {
                        return !teamIds.includes(team._id);
                    });

                    this.setState({ engagementTeams: data, checkedItems: {} }, () => {

                        cb && cb();
                    }
                    );
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    render() {
        const {
            normalizedColumns,
            toggledColumns,
            loading,
            searchTerm,
            checkedItems,
            toggleAddTeam,
            engagementTeams,
            sidePanelOpen,
            toggleDeleteEngagementTeams,
            columns,
            selectedColumnSort,
            sortDesc
        } = this.state;
        const { orgId, eventId } = this.props;
        const sortedTeams = engagementTeams || [];
        ;
        let searchedEntries = sortedTeams;

        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    searchedEntries = searchedEntries.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }

        if (selectedColumnSort) {
            searchedEntries = searchedEntries.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            searchedEntries = sortDesc ? searchedEntries.reverse() : searchedEntries;
        }


        return (
            <Switch>
                <Route path="/:organization/events/:event/engagement/leaderboardTeams">
                    <Fragment>



                        <div className="sectionContainer">
                            {!loading ?
                                <div className="sectionContainer posRel p-0">
                                    {<ActionButtonContainer
                                        mainActions={[
                                            {
                                                type: 'button',
                                                label: 'Add Team',
                                                onClick: () => this.toggleAddTeam(),
                                            }
                                        ]}
                                        searchEnabled={true}
                                        searchEntries={(term) => {
                                            this.setState({ searchTerm: term })
                                        }}

                                    />}
                                    <div className='flex h-100 hasHeader'>
                                        <ViewsTable
                                            title={'Teams'}
                                            columns={normalizedColumns}
                                            toggledColumns={toggledColumns}
                                            data={searchedEntries}
                                            mainColumnActive={true}
                                            checked={this.state.checkedItems}
                                            checkRow={(entryId) => {
                                                const checked = this.state.checkedItems;
                                                checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                                this.updatedCheckedItems(checked);

                                            }}
                                            checkAllRows={(entryIds) => {
                                                let checked = this.state.checkedItems;
                                                entryIds.length > 0
                                                    ? entryIds.forEach((entryId) => {
                                                        checked[entryId] = true;
                                                    })
                                                    : (checked = {});
                                                this.updatedCheckedItems(checked);
                                                this.setState({
                                                    checkedItem: checked
                                                });
                                            }}
                                            sortData={this.sortData}

                                        />
                                    </div>

                                    <ActionButtonContainer
                                        batchActions={
                                            [
                                                {
                                                    type: 'button',
                                                    label: 'Delete Teams',
                                                    onClick: this.toggleDeleteEngagementTeams,
                                                    iconClass: 'las la-trash-alt mr-10',
                                                    class: 'neu danger'
                                                }
                                            ]}
                                        checkedEntryCount={Object.keys(checkedItems).length}
                                        entriesLength={engagementTeams.length}
                                        disableNueFooter={true}
                                        uncheckEntries={() => {
                                            this.setState({ checkedItems: {} });
                                        }}
                                    />
                                </div> :
                                <LoadingWizard
                                    text="Loading Teams"
                                    loading={loading}

                                />}

                            {toggleAddTeam && (
                                <AddTeamModal
                                    isOpen={toggleAddTeam}
                                    toggle={this.toggleAddTeam}
                                    eventId={this.props.eventId}
                                    event={this.props.event}
                                    orgId={this.props.orgId}
                                    addNewTeam={this.addNewTeam}
                                />
                            )}

                            {toggleDeleteEngagementTeams &&
                                <DeleteEngagementTeamsModal
                                    isOpen={toggleDeleteEngagementTeams}
                                    toggle={this.toggleDeleteEngagementTeams}
                                    checkedItems={checkedItems}
                                    deleteEngagementTeams={this.deleteEngagementTeams}

                                />
                            }


                        </div>

                        {/* Side Panel Open */}
                        <div className={`sidePanelContainer ${sidePanelOpen ? 'panelOpen' : ''}`}>
                            <Switch>
                                <Route path={`/:organization/events/:event/engagement/leaderboardTeams/:teamId`}
                                    render={(props) => {
                                        const teamId = props.match.params.teamId;
                                        const team = sortedTeams.find((a) => a._id === teamId);
                                        if (!team) return <Redirect to={`/${orgId}/events/${eventId}/engagement/leaderboardTeams`} />
                                        if (!sidePanelOpen) this.setState({ sidePanelOpen: true })
                                        return <div className='h-100' key={teamId}>

                                            <EngagementTeam
                                                team={team}
                                                orgId={orgId}
                                                eventId={eventId}
                                                event={this.props.event}
                                                updateTeams={this.updateTeams}
                                                attendees={this.props.attendees}
                                            />
                                            <LoadingWizard loading={loading} />
                                        </div>
                                    }}
                                >
                                </Route>
                                <Route exact path={`/:organization/events/:eventId/engagement/leaderboardTeams`}
                                    render={() => {
                                        if (sidePanelOpen) this.setState({ sidePanelOpen: false })
                                        return <></>
                                    }}
                                >
                                </Route>
                            </Switch>
                        </div>
                    </Fragment>

                </Route>
            </Switch>





        );
    }
}

export default withRouter(LeaderboardTeams);
